"use strict";
import axios from "axios";

export const SUNNY = 0;
export const PARTLY_CLOUDY = 1;
export const CLOUDY = 2;
export const RAIN = 3;
export const SLIGHT_RAIN = 4;
export const THUNDERSTORM = 5;
export const SLIGHT_THUNDERSTORM = 6;
export const SNOW = 7;
export const SLIGHT_SNOW = 8;

const noaaUrl = "https://api.weather.gov/gridpoints/SLC/85,170/forecast";

export async function getImminentForecast() {
  let response = {};
  const forecast = await axios.get(noaaUrl);

  console.log("got noaa response: " + JSON.stringify(forecast, null, 2));
  // Get the high temp for the next period
  const useNextPeriodTemp = !forecast.properties.periods[0].isDaytime;
  let index;
  if (useNextPeriodTemp) {
    index = 1;
  } else {
    index = 0;
  }
  response.highTemp = forecast.properties.periods[index].temperature;

  const shortForecast = forecast.properties.periods[0].shortForecast;
  response.forecast = getForecastType(shortForecast);
  console.log("got our response: " + JSON.stringify(response, null, 2));

  return response;
}

function getForecastType(shortForecast) {
  if (shortForecast.match(/snow/i)) {
    if (shortForecast.match(/slight/i)) {
      return SLIGHT_SNOW;
    }
    return SNOW;
  } else if (shortForecast.match(/thunder/i)) {
    if (shortForecast.match(/slight/i)) {
      return SLIGHT_THUNDERSTORM;
    }
    return THUNDERSTORM;
  } else if (shortForecast.match(/rain/i) || shortForecast.match(/shower/i)) {
    if (shortForecast.match(/slight/i)) {
      return SLIGHT_RAIN;
    }
    return RAIN;
  } else if (shortForecast.match(/partly/i)) {
    return PARTLY_CLOUDY;
  }
  return SUNNY;
}
